import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Kaari & Co. — Returning-customers (reorder) campaign (adc_s5hfqdhtdf). Real
// spend, conversions, and reorder ad sales from
// ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS. Nearly dormant: 5
// conversions in 19 months, though each returns ~8x. Monthly series lives in
// realBrandData.ts. The budget is the platform's standing recommendation.
export const campKcReorder: FaireAdCampaignEntity = {
  token: "camp_kc_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_kaari_co",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 100,
  startedRunningAt: "2025-02-14",
  segmentMetrics: {
    numReorderConversions: 5,
    salesDollars: 2229,
    totalAdsSpendDollars: 278,
    returnOnAdSpend: 8.03,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
